import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import Button from '../button/index';
import css from './index.scss';
import { Search, Cross } from '../../helpers/icon-dictionary';

class SearchBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { valueAttr: props.searchTerm };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.searchTerm !== this.props.searchTerm) {
            this.state = { valueAttr: nextProps.searchTerm };
        }
    }

    handleOnSearchTextBoxChanged = (e) => {
        this.setState({ valueAttr: e.target.value });
        this.props.handleOnSearchClick(e.target.value);
    }

    handleOnClearClick = () => {
        const emptyText = '';

        this.props.handleOnSearchClick(emptyText);

        this.setState({ valueAttr: emptyText });
    }

    handleOnSearchClick = () => {
        this.props.handleOnSearchClick(this.state.valueAttr);
    }

    handleOnKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.props.handleOnSearchClick(this.state.valueAttr);
        }
    }

    render() {
        return (
            <div className={css.searchBoxComponent}>
                <div className={css.searchTextBoxComponent}>
                    <input
                        className={css.textBoxSearchText}
                        onChange={this.handleOnSearchTextBoxChanged}
                        onKeyPress={this.handleOnKeyPress}
                        type="text"
                        value={this.state.valueAttr} />
                    <Button
                        buttonContainer={css.buttonContainer}
                        containerClassName={css.searchClearButton}
                        disabled={false}
                        handleOnClick={this.handleOnClearClick}
                        icon={Cross}
                        iconClassName={css.svgIconContainerTextBoxSearch}
                        visible
                    />
                </div>
                <Button
                    containerClassName={css.searchButton}
                    disabled={false}
                    handleOnClick={this.handleOnSearchClick}
                    icon={Search}
                    iconClassName={css.svgIconContainerSearchButton}
                    visible
                />
            </div>
        );
    }
}

SearchBox.propTypes = {
    handleOnSearchClick: PropTypes.func,
    searchTerm: PropTypes.string
};

export default styleable(css)(SearchBox);



// WEBPACK FOOTER //
// ./app/components/search-box/index.js